import type { OpenShiftListItem } from "../../Shift/Open/types";
import { useFortuneCookieInjector } from "./ShiftInjectors/useFortuneCookieInjector";
import { useInAppAdInjector } from "./ShiftInjectors/useInAppAdInjector";
import { useWorkerPaySurveyInjector } from "./ShiftInjectors/useWorkerPaySurveyInjector";

// Injected content, ads, banners, tutorial links, orchestration hooks, etc.
export function useShiftListInjector(shifts: OpenShiftListItem[]): OpenShiftListItem[] {
  let injectedShifts = useInAppAdInjector(shifts);
  injectedShifts = useWorkerPaySurveyInjector(injectedShifts);
  injectedShifts = useFortuneCookieInjector(injectedShifts);

  // The injector handles feature flag check internally
  return injectedShifts;
}
